import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';

import {
    LOAD_STUDY,
    UNLOAD_STUDY,
    UPDATE_STUDY,
    UPDATE_STAGE,
    LOAD_MY_STUDY_PERMISSIONS,
    LOAD_STUDY_METADATA_V4
} from '../actions/study';

export function getStudy(state, action) {
    if (!action || action.type !== LOAD_STUDY) {
        return state;
    }

    const study = { ...state.study, ...action.payload };
    const newState = lodash.cloneDeep(state);
    const formattedStudyTeam = formatSelectedTeamMembers(study.studyTeam);

    lodash.set(newState, 'study', study);
    lodash.set(newState, 'binder', study.binder);
    lodash.set(newState, 'studySettings.studyTeam', formattedStudyTeam);
    lodash.set(newState, 'studySettings.metadata', study.metadata);
    lodash.set(newState, 'studyStageProgressions', study.studyStageProgressions);

    return newState;
}
export function getStudyMetadata(state, action) {
    if (!action || action.type !== LOAD_STUDY_METADATA_V4) {
        return state;
    }
    const study = action.payload;

    return {
        ...state,
        study: { ...state.study, metadata: study.metadata }
    };
}

export function unloadStudy(state, action) {
    if (!action || action.type !== UNLOAD_STUDY) {
        return state;
    }

    const newState = lodash.cloneDeep(state);
    lodash.unset(newState, 'study');
    lodash.unset(newState, 'studySettings');
    lodash.unset(newState, 'binder');
    lodash.unset(newState, 'studyStageProgressions');
    lodash.unset(newState, 'me.binderPermissions');
    lodash.unset(newState, 'me.studyPermissions');
    return newState;
}

export function updateStudy(state, action) {
    if (!action || action.type !== UPDATE_STUDY) {
        return state;
    }

    const study = action.payload;

    state = {
        ...state,
        study: {
            ...state.study,
            ...study,
        }
    };

    return state;
}

const formatSelectedTeamMembers = (data) => {
    return lodash.map(data, teamMember => {
        teamMember.displayName = teamMember.user.displayName;
        teamMember.sub = teamMember.user.sub;
        return teamMember;
    });
};

export function updateStage(state, action) {
    if (!action || action.type !== UPDATE_STAGE) {
        return state;
    }

    state = {
        ...state,
        study: {
            ...state.study,
            currentStage: {
                id: action.payload.id,
                name: action.payload.name,
            },
        },
    };

    return state;
}

export function loadStudyPermissions(state, action) {
    if (!action || action.type !== LOAD_MY_STUDY_PERMISSIONS) {
        return state;
    }

    const permissions = lodash.map(
        action.payload,
        perm => ({
            action: perm.action,
            feature: perm.feature
        })
    );

    state = {
        ...state,
        me: {
            ...state.me,
            studyPermissions: permissions,
        }
    };

    return state;
}

export default composeReducers(
    getStudy,
    updateStudy,
    unloadStudy,
    updateStage,
    loadStudyPermissions,
    getStudyMetadata
);
